/**
 * @typedef {String} module:DeviceService.Permissions
 * @readonly
 * @description Device permissions
 * @property {String} accessControl "accessControl"
 * @property {String} cameraControlPtz "cameraControlPtz"
 * @property {String} dvrAudio "dvrAudio"
 * @property {String} dvrVideo "dvrVideo"
 * @property {String} generateHighlightVideos "generateHighlightVideos"
 * @property {String} eventsDelete "eventsDelete"
 * @property {String} eventsFavorite "eventsFavorite"
 * @property {String} eventsList "eventsList"
 * @property {String} eventsPlayback "eventsPlayback"
 * @property {String} eventsView "eventsView"
 * @property {String} eventsViewed "eventsViewed"
 * @property {String} faceLibraryView "faceLibraryView"
 * @property {String} firmwareUpdate "firmwareUpdate"
 * @property {String} liveAudio "liveAudio"
 * @property {String} liveVideo "liveVideo"
 * @property {String} loginCommandChannel "loginCommandChannel"
 * @property {String} ownerFaceLibraryModify "ownerFaceLibraryModify"
 * @property {String} ownerFaceLibraryView "ownerFaceLibraryView"
 * @property {String} premiumService "premiumService"
 * @property {String} reboot "reboot"
 * @property {String} settingsCam "settingsCam"
 * @property {String} settingsGeneral "settingsGeneral"
 * @property {String} settingsMic "settingsMic"
 * @property {String} settingsMotionDetection "settingsMotionDetection"
 * @property {String} settingsNotification "settingsNotification"
 * @property {String} settingsSpk "settingsSpk"
 * @property {String} voiceControlApis "voiceControlApis"
 */
const permissions = Object.freeze({
    accessControl: 'accessControl',
    cameraControlPtz: 'cameraControlPtz',
    dvrAudio: 'dvrAudio',
    dvrVideo: 'dvrVideo',
    generateHighlightVideos: 'generateHighlightVideos',
    eventsDelete: 'eventsDelete',
    eventsFavorite: 'eventsFavorite',
    eventsList: 'eventsList',
    eventsPlayback: 'eventsPlayback',
    eventsView: 'eventsView',
    eventsViewed: 'eventsViewed',
    faceLibraryView: 'faceLibraryView',
    firmwareUpdate: 'firmwareUpdate',
    liveAudio: 'liveAudio',
    liveVideo: 'liveVideo',
    loginCommandChannel: 'loginCommandChannel',
    ownerFaceLibraryModify: 'ownerFaceLibraryModify',
    ownerFaceLibraryView: 'ownerFaceLibraryView',
    premiumService: 'premiumService',
    reboot: 'reboot',
    settingsCam: 'settingsCam',
    settingsGeneral: 'settingsGeneral',
    settingsMic: 'settingsMic',
    settingsMotionDetection: 'settingsMotionDetection',
    settingsNotification: 'settingsNotification',
    settingsSpk: 'settingsSpk',
    voiceControlApis: 'voiceControlApis'
});

export default permissions;
